var map = {
  "./cs.json": [
    "wT",
    [
      "6z"
    ]
  ],
  "./en.json": [
    "yT",
    [
      "k8n"
    ]
  ],
  "./pl.json": [
    "Rf",
    [
      "ngq"
    ]
  ],
  "./ru.json": [
    "HQ",
    [
      53
    ]
  ],
  "./tr.json": [
    "GT",
    [
      "g7"
    ]
  ],
  "./ja.json": [
    "ln4",
    [
      "zj"
    ]
  ],
  "./zh.json": [
    "ap",
    [
      "w"
    ]
  ],
  "./pt-br.json": [
    "w7",
    [
      "ehw"
    ]
  ],
  "./de.json": [
    "dd",
    [
      "v6"
    ]
  ],
  "./es.json": [
    "M5l",
    [
      "qqq"
    ]
  ],
  "./fr.json": [
    "hd",
    [
      "rs"
    ]
  ],
  "./it.json": [
    "hL",
    [
      "f5b"
    ]
  ],
  "./ko.json": [
    "a6",
    [
      "sp"
    ]
  ],
  "./pt.json": [
    "DN",
    [
      "pq"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "rZ";
module.exports = __rspack_async_context;
